import React from 'react';
import { usePermissions } from '../hooks/usePermissions';
import Workers from './Workers';

interface WorkersCompProps {
  canAdd: boolean;
  canEdit: boolean;
  canDelete: boolean;
}

const WorkersPage: React.FC = () => {
  const { canView, canAdd, canEdit, canDelete } = usePermissions();

  if (!canView('workers')) {
    return null;
  }

  const WorkersComp = Workers as React.ComponentType<WorkersCompProps>;

  return (
    <WorkersComp
      canAdd={canAdd('workers')}
      canEdit={canEdit('workers')}
      canDelete={canDelete('workers')}
    />
  );
};

export default WorkersPage; 